import { useSelector } from "react-redux";
import AccommodationsPricing from "./AccommodationsPricing";
import { getAccommodationsPrices } from "app/pages/Booking/bookingSelectors";

const AccommodationsPricingContainer = () => {
	const accommodationsPrices = useSelector(getAccommodationsPrices);
	return <AccommodationsPricing accommodationsPrices={accommodationsPrices} />;
};

export default AccommodationsPricingContainer;
